import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "react-bootstrap";
import StatisticsCard from "./components/StatisticsCard";
import PieChart from "./components/PieChart";
import { setActiveTab, setTrendViewOptions } from "../slice";
import "./overview.css";

const OverviewView = () => {
  const dispatch = useDispatch();
  const {
    selectedPeriod,
    statistics,
    overviewData,
    overviewLoading,
    overviewError,
    completedOnly,
  } = useSelector((state) => state.dashboard);

  const handleViewTrend = (title) => {
    let viewOptions;

    switch (title) {
      case "Total Income":
        viewOptions = { showIncome: true, showJobs: false };
        break;
      case "Total Jobs":
        viewOptions = { showIncome: false, showJobs: true };
        break;
      case "Avg Income":
        viewOptions = { showIncome: true, showJobs: true };
        break;
      default:
        viewOptions = { showIncome: true, showJobs: true };
    }

    dispatch(setTrendViewOptions(viewOptions));
    dispatch(setActiveTab("trend"));
  };

  return (
    <>
      {/* Statistics Cards Section */}
      <div className="statistics-section">
        <Row className="statistics-row">
          <Col lg={4} md={6} className="statistics-col">
            <StatisticsCard
              title="Total Income"
              value={statistics?.totalIncome?.value || "$0"}
              percentage={statistics?.totalIncome?.percentage || "0%"}
              isPositive={statistics?.totalIncome?.isPositive ?? true}
              period={selectedPeriod}
              statistics={statistics}
              completedOnly={completedOnly}
              selectedPeriod={selectedPeriod}
              onViewTrend={handleViewTrend}
            />
          </Col>
          <Col lg={4} md={6} className="statistics-col">
            <StatisticsCard
              title="Total Jobs"
              value={statistics?.totalJobs?.value || "0"}
              percentage={statistics?.totalJobs?.percentage || "0%"}
              isPositive={statistics?.totalJobs?.isPositive ?? true}
              period={selectedPeriod}
              statistics={statistics}
              completedOnly={completedOnly}
              selectedPeriod={selectedPeriod}
              onViewTrend={handleViewTrend}
            />
          </Col>
          <Col lg={4} md={12} className="statistics-col">
            <StatisticsCard
              title="Avg Income"
              value={
                statistics?.avgIncome?.value
                  ? `${statistics.avgIncome.value} ${statistics.avgIncome.subtitle || "/per job"}`
                  : "$0 /per job"
              }
              percentage={statistics?.avgIncome?.percentage || "0%"}
              isPositive={statistics?.avgIncome?.isPositive ?? true}
              period={selectedPeriod}
              statistics={statistics}
              completedOnly={completedOnly}
              selectedPeriod={selectedPeriod}
              onViewTrend={handleViewTrend}
            />
          </Col>
        </Row>
        <div className="statistics-note">*Only completed jobs are included</div>
      </div>

      {/* Pie Chart Analytics Section */}
      {overviewLoading ? (
        <div className="loading-container">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : overviewError ? (
        <div className="error-container alert alert-danger">
          Error loading dashboard data: {overviewError}
        </div>
      ) : (
        <div className="analytics-section">
          <Row className="analytics-row">
            <Col xl={6} lg={12} className="analytics-col">
              <PieChart
                title="Top Agent"
                type="agent"
                data={
                  overviewData?.top_metrics?.top_agent_income || {
                    agents: [],
                    others: null,
                  }
                }
              />
            </Col>
            <Col xl={6} lg={12} className="analytics-col">
              <PieChart
                title="Top Property Type"
                type="property"
                data={
                  overviewData?.top_metrics?.top_property_type || {
                    property_types: [],
                    others: null,
                  }
                }
              />
            </Col>
            <Col xl={6} lg={12} className="analytics-col">
              <PieChart
                title="Top Region"
                type="region"
                data={
                  overviewData?.top_metrics?.top_region || {
                    regions: [],
                    others: null,
                  }
                }
              />
            </Col>
            <Col xl={6} lg={12} className="analytics-col">
              <PieChart
                title="Top Quote Range"
                type="quote"
                data={
                  overviewData?.top_metrics?.top_quote_range || {
                    quote_ranges: [],
                    others: null,
                  }
                }
              />
            </Col>
          </Row>
          <div className="analytics-note">
            *Only completed jobs are included
          </div>
        </div>
      )}
    </>
  );
};

export default OverviewView;
